import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches the currently-logged-in admin's profile (username, email, role).
 * Returns `{ me, loading, isAdmin }`. Defaults to `isAdmin: true` while
 * loading so admin-only UI doesn't briefly flash for actual admins.
 */
export const useCurrentAdmin = () => {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      setLoading(false);
      return;
    }
    axios
      .get(`${BACKEND_URL}/api/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setMe(res.data))
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  }, []);

  const isAdmin = !me ? loading : (me.role || 'admin') === 'admin';
  return { me, loading, isAdmin };
};
